export default function getBudgetPreferenceLabel(budget_preference?: number): string {
  switch (budget_preference) {
    case undefined:
      return "None"
    case 0:
      return "Cheapest"
    case 1:
      return "Cheap"
    case 2:
      return "Mid-range"
    case 3:
      return "Semi-gourmet"
    case 4:
      return "Gourmet"
    default:
      return "unknown"
  }
}
